// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"be5c80a9","645":"5d85772e"}[chunkId] + ".chunk.css";
};